import { CONTRACT_TYPE } from '@spa/shared/constants/contractType';
export var getPricing = function getPricing(_ref) {
  var _contract$contractTyp, _contract$contractTyp2, _priceDetailsData$ren;
  var accommodationOffer = _ref.accommodationOffer,
    priceDetailsRequest = _ref.priceDetailsRequest,
    priceDetailsData = _ref.priceDetailsData;
  var contract = accommodationOffer.contract,
    referencePrice = accommodationOffer.reference_price;
  var guests = priceDetailsRequest.guests;
  var isAnyTypeFixed = [CONTRACT_TYPE.FIXED, CONTRACT_TYPE.FIXED_UNITARY].includes(contract.type);
  var contractType = isAnyTypeFixed ? 'fixed_unitary' : 'standard';
  var extraPerGuest = (_contract$contractTyp = contract[contractType]) === null || _contract$contractTyp === void 0 ? void 0 : _contract$contractTyp.extra_per_guest;
  var extraAfter = (_contract$contractTyp2 = contract[contractType]) === null || _contract$contractTyp2 === void 0 ? void 0 : _contract$contractTyp2.extra_after;
  var isExtraPerGuestAppliable = extraPerGuest && extraPerGuest.amount > 0 && guests > extraAfter;
  var extraPriceAmount = isExtraPerGuestAppliable ? extraPerGuest.amount * (guests - extraAfter) : 0;
  var _ref2 = ((priceDetailsData === null || priceDetailsData === void 0 ? void 0 : (_priceDetailsData$ren = priceDetailsData.rents) === null || _priceDetailsData$ren === void 0 ? void 0 : _priceDetailsData$ren.items) || []).find(function (_ref3) {
      var value = _ref3.value;
      return !!(value !== null && value !== void 0 && value.amount);
    }) || {},
    firstRentValue = _ref2.value;
  return {
    isAnyTypeFixed: isAnyTypeFixed,
    extraPriceAmount: extraPriceAmount,
    firstRentValue: firstRentValue,
    referencePrice: referencePrice
  };
};